import React from "react";

const TYPE_LABELS = {
  PRODUCT: "Product",
  SERVICE: "Service",
  SOLUTION: "Solution",
};

const OfferingTypeBadge = ({ type }) => {
  const label = TYPE_LABELS[type] || type || "Unknown";

  return (
    <span
      className={`offering-type-badge ${
        type ? type.toLowerCase() : ""
      }`}
    >
      {label}
    </span>
  );
};

export default OfferingTypeBadge;